
import React from 'react'
import { createRoot } from 'react-dom/client'
import App from './App'
import './index.css'
import Clarity from '@microsoft/clarity';
import ErrorBoundary from './components/ErrorBoundary';

// Initialize Clarity with the project ID
if (typeof window !== 'undefined') {
  try {
    Clarity.init("pu00rywx6p");
  } catch (e) {
    console.error("Failed to initialize Clarity:", e);
  }
}

function initializeApp() {
  console.log("Initializing app...");
  
  const rootElement = document.getElementById("root");
  if (!rootElement) {
    console.error('Failed to find the root element');
    return;
  }

  try {
    console.log("Creating root...");
    const root = createRoot(rootElement);
    
    console.log("Rendering app...");
    root.render(
      <React.StrictMode>
        <ErrorBoundary>
          <App />
        </ErrorBoundary>
      </React.StrictMode>
    );
    console.log("App rendered successfully");
  } catch (error) {
    console.error("Error rendering the app:", error);
    
    // Display a basic error message if rendering fails
    rootElement.innerHTML = `
      <div style="padding: 20px; max-width: 800px; margin: 0 auto; font-family: system-ui;">
        <h1>Application Error</h1>
        <p>We're sorry, but the application failed to load. Please refresh the page or try again later.</p>
        <pre style="background: #f5f5f5; padding: 10px; border-radius: 4px; overflow: auto;">${error?.message || 'Unknown error'}</pre>
      </div>
    `;
  }
}

// Ensure the DOM is fully loaded before trying to mount the app
if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', initializeApp);
} else {
  initializeApp();
}
